import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getHolidayFailed,
  getHolidayStart,
  getHolidaySuccess,
} from "../redux/getHolidays";
import { getHolidayAPI } from "core/http/service/decleareLeave";

function* getHolidayWork(action) {
  const { month, year } = action.payload;
  try {
    const res = yield call(getHolidayAPI, month, year);

    yield put({
      type: getHolidaySuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getHolidayFailed.type,
    });
  }
}

function* watchGetHoliday() {
  yield takeLatest(getHolidayStart.type, getHolidayWork);
}

export default function* getArriveLateDetailSaga() {
  yield all([watchGetHoliday()]);
}
